import angular from 'angular';

import directive from './stickyNav.directive';
import './stickyNav.scss';

import browser from 'cars-ng-browser';
import ActiveTest from '../carsNgActiveTest';
import CarsNgEmployees from 'cars-ng-employees';

import Listing from '../listing/index';
import SellerData from '../sellerData';
import NgBrowser from 'cars-ng-browser';
import NgTracking from 'cars-ng-tracking';
import DealerChat from '../dealerChat';

import LeadForm from '../leadForm';

export default angular.module('cars.enhanced.vdp.stickyNav', [
    browser,
    ActiveTest,
    CarsNgEmployees,
    Listing,
    SellerData,
    NgBrowser,
    NgTracking,
    DealerChat,
    LeadForm
])

.directive('carsVdpEnhancedStickyNav', directive)
.name;
